// import moment from 'moment'
import { cleanDate } from '@/filters/filters';
import dayjs from 'dayjs';
// import { Context } from './Formulas/Shared';

// YYYY-01-01
export const currentYearStartDate = dayjs().startOf('year').format('YYYY-MM-DD')
/*export const currentYearStartDate = dayjs().startOf('year').toDate() < new Date()
? dayjs().startOf('year').add(1, 'year').format('YYYY-MM-DD')
: dayjs().startOf('year').format('YYYY-MM-DD')*/

export const monthShortNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// Number of days in each month
export const daysInMonth: any = {
	jan: 31,
	feb: 28/*dayjs((dayjs().format('YYYY') + '-02'), 'YYYY-MM').daysInMonth()*/,
	mar: 31,
	apr: 30,
	may: 31,
	jun: 30,
	jul: 31,
	aug: 31,
	sep: 30,
	oct: 31,
	nov: 30,
	dec: 31
}

export interface AvailableDate {
	start: string;
	mid: string;
	period: number;
	periodLength: number;
	month: number;
	daysInMonth: number;
	getInstance: (date?: string | Date) => dayjs.Dayjs;
}

export const currentYear = new Date().getFullYear();
export const AvailableDates: AvailableDate[] = [
	{ start: '1 Jan', mid: '8 Jan', period: 1, periodLength: 15, month: 1 },
	{ start: '16 Jan', mid: '23 Jan', period: 2, periodLength: 16, month: 1 },
	{ start: '1 Feb', mid: '8 Feb', period: 3, periodLength: 14, month: 2 },
	{ start: '15 Feb', mid: '22 Feb', period: 4, periodLength: 15, month: 2 },
	{ start: '1 Mar', mid: '8 Mar', period: 5, periodLength: 15, month: 3 },
	{ start: '16 Mar', mid: '23 Mar', period: 6, periodLength: 16, month: 3 },
	{ start: '1 Apr', mid: '8 Apr', period: 7, periodLength: 15, month: 4 },
	{ start: '16 Apr', mid: '23 Apr', period: 8, periodLength: 15, month: 4 },
	{ start: '1 May', mid: '8 May', period: 9, periodLength: 15, month: 5 },
	{ start: '16 May', mid: '23 May', period: 10, periodLength: 16, month: 5 },
	{ start: '1 Jun', mid: '8 Jun', period: 11, periodLength: 15, month: 6 },
	{ start: '16 Jun', mid: '23 Jun', period: 12, periodLength: 15, month: 6 },
	{ start: '1 Jul', mid: '8 Jul', period: 13, periodLength: 15, month: 7 },
	{ start: '16 Jul', mid: '23 Jul', period: 14, periodLength: 16, month: 7 },
	{ start: '1 Aug', mid: '8 Aug', period: 15, periodLength: 15, month: 8 },
	{ start: '16 Aug', mid: '23 Aug', period: 16, periodLength: 16, month: 8 },
	{ start: '1 Sep', mid: '8 Sep', period: 17, periodLength: 15, month: 9 },
	{ start: '16 Sep', mid: '23 Sep', period: 18, periodLength: 15, month: 9 },
	{ start: '1 Oct', mid: '8 Oct', period: 19, periodLength: 15, month: 10 },
	{ start: '16 Oct', mid: '23 Oct', period: 20, periodLength: 16, month: 10 },
	{ start: '1 Nov', mid: '8 Nov', period: 21, periodLength: 15, month: 11 },
	{ start: '16 Nov', mid: '23 Nov', period: 22, periodLength: 15, month: 11 },
	{ start: '1 Dec', mid: '8 Dec', period: 23, periodLength: 15, month: 12 },
	{ start: '16 Dec', mid: '23 Dec', period: 24, periodLength: 15, month: 12 },
].map(d => ({
	...d, daysInMonth: dayjs(cleanDate(d.start, 'D MMM'), 'D MMM').daysInMonth(), getInstance: (date?: string | Date) => dayjs(`${date || d.start} ${currentYear}`)
}));

export const MidpointDates = AvailableDates.map(d => d.mid);
export const StartDates = AvailableDates.map(d => d.start);
export const PeriodLengths = AvailableDates.map(d => d.periodLength);
export const Months = new Array(12).fill(0).map((_, ix) => ix + 1);
export const Periods = AvailableDates.map(d => d.period);

export const StringMap = AvailableDates.map(d => ({ [dayjs(d.start, 'D MMM').format('MM-DD')]: d })).reduce((agg, v) => ({ ...agg, ...v }));
export function fromDate(date: string | Date): AvailableDate | null | undefined {
	return StringMap[dayjs(date).format('MM-DD')];
}

export const PeriodMap = AvailableDates.map(d => ({ [d.period]: d })).reduce((agg, v) => ({ ...agg, ...v }));
export function fromPeriod(period: number): AvailableDate {
	return PeriodMap[period];
}

export const MonthMap = AvailableDates.map(d => ({ [d.month]: d })).reduce((agg, v) => ({ ...agg, ...v }));
export function fromMonth(month: number): AvailableDate {
	return MonthMap[month];
}

// Returns an array of months in order, starting with the Start Date month
export function MonthsInOrder(startDate: string | Date) {
	const currentMonth = dayjs(startDate).month();
	return new Array(12).fill(0).map((_, ix) => ((ix + currentMonth) % 12) + 1);
}

export default AvailableDates;
// window['moment'] = moment;
